/**
 * 挂件曝光 trigger_scene 推导（widget_retention_show.trigger_scene）
 *
 * - 写入路径看 session.widgetSource（TWidgetSource）
 * - 展示触发看本函数（TWidgetShowTrigger）；二者解耦，勿互相覆盖
 *
 * 调用时机：WidgetHost 确认挂件「新进入可见列表」并准备打 widget_retention_show 时。
 */

import type { TWidgetShowTrigger, TWidgetSource } from './types';

/**
 * 按写入来源 + 是否已首次曝光，解析挂件 trigger_scene。
 * @param widgetSource session 写入路径；冷启首次可见映射为 cold_start
 * @param hasTrackedShow 该 activityId 是否已报过挂件曝光（Host 内 ref Set）
 * @returns cold_start | tab_switch
 */
export function resolveWidgetShowTrigger(
    widgetSource: TWidgetSource | undefined,
    hasTrackedShow: boolean
): TWidgetShowTrigger {
    // 冷启写入且尚未报过曝光 → 计为冷启触发
    if (!hasTrackedShow && widgetSource === 'cold_start') {
        return 'cold_start';
    }
    // 已曝光再可见，或非冷启写入的首次可见 → 切 Tab / 其它展示触发
    return 'tab_switch';
}
